import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import { cardVariants, stepSlideVariants } from '../animations';

export type LoginStep = 'credentials' | 'channel' | 'otp';

interface LoginCardProps {
  step: LoginStep;
  direction: number;
  children: React.ReactNode;
}

const LoginCard: React.FC<LoginCardProps> = ({ step, direction, children }) => {
  return (
    <motion.div
      variants={cardVariants}
      initial="initial"
      animate="animate"
      className="relative w-full"
    >
      <div
        aria-hidden="true"
        className="absolute -inset-[2px] rounded-[22px] opacity-80"
        style={{
          background: 'linear-gradient(135deg, #C00035 0%, #FFC107 100%)',
        }}
      />
      <div className="relative bg-white rounded-[20px] shadow-xl shadow-haat-red-200/40 overflow-hidden">
        <div className="px-6 sm:px-8 py-7 sm:py-8 min-h-[440px] flex flex-col justify-center">
          <AnimatePresence mode="wait" custom={direction}>
            <motion.div
              key={step}
              custom={direction}
              variants={stepSlideVariants}
              initial="initial"
              animate="animate"
              exit="exit"
            >
              {children}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </motion.div>
  );
};

export default LoginCard;
